import { useEffect } from 'react';
import { useAuth } from './useAuth';

/**
 * 読み込み完了かつ未認証なら指定の遷移を行う（結果画面を直接踏まれた場合にトップへ戻すための保護）。
 * ただし認証エラー時は遷移しない。/result は Auth0 コールバックの戻り先でもあり、
 * ?error=... や handleRedirectCallback 失敗を黙って隠してトップへ戻さないため、エラーは画面に残す。
 */
export function useLoginRequired(redirect: () => void) {
  const { isLoading, isAuthenticated, error } = useAuth();
  useEffect(() => {
    if (!isLoading && !isAuthenticated && !error) {
      redirect();
    }
  }, [isLoading, isAuthenticated, error, redirect]);
}
